// Copyright © 2024 Move Closer

import { Component } from 'vue-property-decorator'

import {
  TextListWithAddons,
  Tile,
  ThumbnailsListWithAddons,
  TileSize,
  ListType,
  TileSizeMobile
} from '../../_components/ui'

import { InnerGridWrapper } from '../_partials'
import { TeaserBoxVersion } from '../TeaserBox.contracts'
import { ModuleAdditionalRows } from '../../_contracts'
import { TeaserBoxAddonsMixin } from '../TeaserBox.shared'

/**
 * XL-3S-text-list layout with addon support:
 * - Left side: 1 XL tile + 3 S tiles (positions 0-3) with addons
 * - Right side: TextListWithAddons for articles 4+ with addons
 * Layout: [XL][S][TextList]
 *         [  ][S][       ]
 *         [  ][S][       ]
 */
@Component({
  name: 'TeaserBoxInnerGridXL3STextList',
  components: { InnerGridWrapper, TextListWithAddons, Tile, ThumbnailsListWithAddons },
  template: `
    <InnerGridWrapper>
    <template v-if="tiles && tiles.length">
      <!-- Left side: XL tile + S tiles and Addons -->
      <template v-for="item in tiles">
        <component :is="getComponentType(item)" v-bind="getComponentProps(item)" :key="item.key" />
      </template>
      <!-- Right side: TextList with Addons -->
      <template v-if="!isMobile && listComponent">
        <div :class="gridStyle">
          <component :is="listComponent.component" v-bind="getComponentProps(listComponent)" :key="listComponent.key" />
        </div>
      </template>
    </template>
    </InnerGridWrapper>
  `
})
export class TeaserBoxInnerGridXL3STextList extends TeaserBoxAddonsMixin {
  public static readonly moduleVersion: TeaserBoxVersion = TeaserBoxVersion['XL-3S-text-list']

  public gridConfig = {
    defaultSize: TileSize.S,
    mobileSize: TileSizeMobile.TILE_PLUS_TEXT,
    tiles: {
      0: TileSize.XL
    },
    listOffset: 4,
    listType: ListType.LIST
  }

  public get tilesOffset (): number {
    switch (this.teaserBoxConfig.additionalRows) {
      case ModuleAdditionalRows.addOne:
        return this.gridConfig.listOffset + 3 // XL + 3S + 3 additional = 7 tiles
      case ModuleAdditionalRows.addTwo:
        return this.gridConfig.listOffset + 6 // XL + 3S + 6 additional = 10 tiles
      default:
        return this.gridConfig.listOffset // XL + 3S = 4 tiles (positions 0-3)
    }
  }
}
